import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

import { MaterialModule } from '../ng-material/ng-material.module';
import { SharedModule } from '../shared/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';

//Components
import { HeaderComponent } from './header/header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FileImportComponent } from './components/file-import/file-import.component';
import { ItinenaryListComponent } from './components/itinenary-list/itinenary-list.component';
import { RenderMapComponent } from './components/render-map/render-map.component';
import { MapSearchComponent } from './components/render-map/map-search/map-search.component';
import { MapRouteComponent } from './components/render-map/map-route/map-route.component';
import { ItineraryRouteComponent } from './components/itinerary-route/itinerary-route.component';
import { FileExportComponent } from './components/file-import/file-export.component';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { AddUserComponent } from './add-user/add-user.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserSessionComponent } from './user-session/user-session.component';
import { FileExportSaveLocallyComponent } from './components/file-import/file-export.save.locally.component';

//Dialog Components
import { ItinenaryCrudDialog } from './components/itinenary-list/itinenary-crud/itinenary-crud.dialog';
import { CsvConfigDialog } from './components/file-import/csv-config/csv-config.dialog';
import { MapSettingsDialog } from './map-settings/map-settings.dialog';
import { SaveAsDialog } from './components/file-import/save-as/save-as.dialog';

//Services
import { FileDataService } from './components/services/file-data.service';
import { MapDataService } from './components/services/map-data.service';
import { MapMarkerService } from './components/services/map-marker.service';
import { MapSharedService } from './components/services/map-shared.service';
import { SettingService } from './services/setting.service';
import { TrackTypeDialog } from './components/file-import/track-type/track-type.dialog';
import { AuditService } from './services/audit.services';
import { AddUserService } from './services/adduser.services';
import { UserProfileService } from './components/services/userprofile.services';
import { UserSessionService } from './services/usersession.services';
import { DatePipe } from "@angular/common";

@NgModule({
  declarations: [
    HeaderComponent,
    DashboardComponent,
    MapSettingsDialog,
    FileImportComponent,
    ItinenaryListComponent,
    ItinenaryCrudDialog,
    CsvConfigDialog,
    RenderMapComponent,
    SaveAsDialog,
    TrackTypeDialog,
    MapSearchComponent,
    MapRouteComponent,
    ItineraryRouteComponent,
    FileExportComponent,
    AuditTrailComponent,
    AddUserComponent,
    UserProfileComponent,
    UserSessionComponent,
    FileExportSaveLocallyComponent
  ],
  imports: [
    LeafletModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DashboardRoutingModule,
    
  ],
  providers:[
    FileDataService,
    MapDataService,
    SettingService,
    MapMarkerService,
    MapSharedService,
    AuditService,
    AddUserService,
    UserProfileService,
    UserSessionService,
    DatePipe
  ],
  entryComponents :[
    ItinenaryCrudDialog,
    CsvConfigDialog,
    MapSettingsDialog,
    FileImportComponent,
  ]
})
export class DashboardModule { }
